import { UseBaseMutationOptions } from '@/core/api/type'
import { useMutation } from '@tanstack/react-query'
import { GameMutationKeys } from '../../../keys'
import {
	UpdateGameProviderResponse,
	UpdateGameProviderRequest,
} from '../../../type'
import { updateGameProvider } from '../../services'

interface UpdateGameProviderParams {
	id: string
	payload: UpdateGameProviderRequest
}

export default function useMutationUpdateProvider(
	props?: UseBaseMutationOptions<
		UpdateGameProviderResponse,
		UpdateGameProviderParams
	>,
) {
	return useMutation({
		mutationKey: [GameMutationKeys.UpdateGameProvider],
		mutationFn: (params) => updateGameProvider(params.payload, params.id),
		...props,
	})
}
